import { useEffect } from "react";

/**
 * 1NOW-10428 — set the document title.
 *
 * Replaces `react-helmet`. Every `<Helmet>` in this app only ever set a
 * `<title>` — no meta, no link tags — and the library stopped emitting
 * anything at all under React 18's concurrent root, so every tenant page was
 * stuck on the static "Car rental" from index.html. Swapping to
 * `react-helmet-async` did not fix it either: with a `HelmetProvider` correctly
 * above the tree, a literal `<Helmet><title>…</title></Helmet>` still produced
 * no output and no error.
 *
 * Rather than keep debugging a dependency for something this small, the title
 * is now set directly. One effect, no provider, no library — and it cannot
 * silently no-op.
 *
 * Pass a falsy value to leave the current title alone (e.g. while the tenant's
 * details are still loading), so pages don't flash a placeholder first.
 */
export const useDocumentTitle = (title?: string | null): void => {
  useEffect(() => {
    const next = (title || "").trim();
    if (!next || document.title === next) return;
    document.title = next;
  }, [title]);
};

export default useDocumentTitle;
